import jqRequest from '../jqRequest'
import reportUrls from '../urls/report'

export default {
  // 获取报料详情
  getReportDetailById(data){
    return jqRequest.requestWithToken(reportUrls.getDiscloseMaterialInfo, data);
  },
  // 查询报料频道
  listDiscloseChannelByCategoryCode(data){
    return jqRequest.requestWithToken(reportUrls.listDiscloseChannelByCategoryCode, data);
  },
  // 获取频道下报料列表
  listDiscloseMaterialByPublish(data){
    return jqRequest.requestWithToken(reportUrls.listDiscloseMaterialByPublish, data);
  },
  // 获取我的报料列表
  listDiscloseMaterialByMemberId(data){
    return jqRequest.requestWithToken(reportUrls.listDiscloseMaterialByMemberId, data);
  },
  // 添加报料
  addDiscloseMaterial(memberId,nodeCode,data){
    return jqRequest.requestWithContentTypeAndToken(reportUrls.addDiscloseMaterial + "?memberId=" + memberId + "&nodeCode=" + nodeCode, data);
  },
}